
<template>
  <div class="download_page" :style="styleObj">
    <div>
      <img class="logo" src="../../assets/tflogo.png" alt="">
    </div>
    <div>
      <img class="word" src="../../assets/tfword.png" alt="">
    </div>
    <div class="btn" :class="isIos() ? '' : 'btn_green'" id="downloadButton">
      <span v-if="isIos()"><img class="btn_img" src="../../assets/ios.png" alt="">IOS版下载</span>
      <span v-else><img class="btn_img" src="../../assets/android.png" alt="">安卓版下载</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "download",
  data() {
    return {
      styleObj: {},
      contentHeight: document.documentElement.clientHeight
    }
  },
  mounted() {
    this.styleObj = {
      height: this.contentHeight + 'px'
    }
    var data = XInstall.parseUrlParams(); //xinstall.js中提供的工具函数，解析url中的所有查询参数，函数返回格式为js Object
    new XInstall({
      /*xinstall中应用的唯一标识，用于识别您的应用*/
      appKey : "mq81ipn",
      /*xinstall初始化完成的回调函数*/
      onready : function() {
        var m = this, button = document.getElementById("downloadButton");
        /*用户点击您页面上的某个按钮时(假定您的按钮id为downloadButton)，安装app*/
        button.onclick = function() {
          m.wakeupOrInstall();
        }
      }
    }, data);
  },
  methods: {
    isIos() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      return isiOS
    },
  }
}
</script>

<style scoped>
.download_page {
  text-align: center;
  position: relative;
}
.logo {
  height: 89px;
  margin: 30px auto;
}
.word {
  height: 149px;
  margin: auto;
}
.btn {
  width: 276px;
  height: 40px;
  line-height: 40px;
  background: #3C74F2;
  border-radius: 20px;
  font-size: 16px;
  color: #fff;
  position: absolute;
  bottom: 78px;
  left: 50%;
  margin-left: -138px;
}
.btn.btn_green {
  background: #00C750;
}
.btn_img {
  width: 20px;
  margin-top: -4px;
  margin-right: 12px;
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/download.vue